export default __webpack_public_path__ + "static/media/DRIVERLICENSEDOCTORCERTIFICATE.cb39415c.png";